import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function showUsersList() {
    return axios.get(`${url}/admin/list`).then(response => {
        return {
            usersList: response.data,
        };
    });
}

function adminSkillsData() {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_skills`, options).then(response => {
        return {
            adminSkillsData: response.data
        };
    });
}

function userSkillsData(user_login) {
    const payload = JSON.stringify({user_login});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/skills`, payload, options).then(response => {
        return {
            userSkillsData: response.data
        };
    });
}

function userSkills(user_login) {
    const payload = JSON.stringify({user_login});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/user_skills`, payload, options).then(response => {
        return {
            userSkills: response.data
        };
    });
}

export default {
    showUsersList,
    adminSkillsData,
    userSkillsData,
    userSkills
};